/* global axios */

const dependencyCache = new Map();

const dependencyEndpoint = () =>
  window.chatwootConfig?.customAttributeDependencyUrl ||
  window.globalConfig?.CUSTOM_ATTRIBUTE_DEPENDENCY_URL ||
  window.globalConfig?.customAttributeDependencyUrl ||
  '';

const endpointForAccount = accountId => {
  const endpoint = dependencyEndpoint();
  if (!endpoint || !accountId) return '';

  if (endpoint.includes(':accountId')) {
    return endpoint.replace(':accountId', accountId);
  }

  const url = new URL(endpoint, window.location.origin);
  url.searchParams.set('account_id', accountId);
  return url.toString();
};

const normalizeDependency = dependency => {
  const parentKey =
    dependency.parent_key ||
    dependency.parentAttributeKey ||
    dependency.parent_attribute_key;
  const childKey =
    dependency.child_key ||
    dependency.childAttributeKey ||
    dependency.child_attribute_key;
  const mapping =
    dependency.allowed_values_mapping ||
    dependency.allowed_values ||
    dependency.allowedValueMapping ||
    dependency.dependency_mapping ||
    dependency.mapping ||
    {};

  if (!parentKey || !childKey || typeof mapping !== 'object') return null;

  return {
    parentKey,
    childKey,
    mapping,
  };
};

const normalizeDependencies = payload => {
  const dependencies =
    payload?.dependencies ||
    payload?.custom_attribute_dependencies ||
    payload?.payload ||
    payload ||
    [];

  if (!Array.isArray(dependencies)) return [];

  return dependencies.map(normalizeDependency).filter(Boolean);
};

export const fetchCustomAttributeDependencies = async accountId => {
  const url = endpointForAccount(accountId);
  if (!url) return [];

  if (!dependencyCache.has(url)) {
    dependencyCache.set(
      url,
      axios
        .get(url)
        .then(response => normalizeDependencies(response.data))
        .catch(() => [])
    );
  }

  return dependencyCache.get(url);
};
